import { useEffect, useRef } from 'react'

/**
 * @returns a ref that is set to false when the component is unmounted
 */
export const useMountedRef = () => {
  const mounted = useRef(true)

  useEffect(() => {
    return () => { mounted.current = false }
  }, [])

  return mounted
}
